import { render, staticRenderFns } from "./QuizzesItemNow.vue?vue&type=template&id=186b7a62&scoped=true&"
import script from "./QuizzesItemNow.vue?vue&type=script&lang=js&"
export * from "./QuizzesItemNow.vue?vue&type=script&lang=js&"
import style0 from "./QuizzesItemNow.vue?vue&type=style&index=0&id=186b7a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b7a62",
  null
  
)

export default component.exports